import React from "react";
import "./AviatorCard.css";

const AviatorCard = () => {
  return (
    <div className="aviator-card-wrapper">
      <div className="aviator-card">
        {/* Top Metallic Header Badge */}
        <div className="card-header-badge">
          <span>Fun Aviator</span>
        </div>

        {/* Card Body Content */}
        <div className="card-body">
          <p className="intro-text">
            We are thrilled to introduce our latest game
          </p>

          <h1 className="main-title">Fun Aviator</h1>

          <p className="body-text">
            To enjoy uninterrupted access, download the latest version of the
            app from https://mydgp.online
          </p>
        </div>
      </div>
    </div>
  );
};

export default AviatorCard;
